<template>
	<div class="customizer-tmall-wishlist">
		<div class="customizer-tmall-wishlist-notification">
			<div class="customizer-tmall-wishlist-notification-text">{{ textMessage }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TmallWishlistNotification",
  props: {
    favoriteSaved: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    isFavoriteSaved() {
			return this.favoriteSaved;
    },
    textMessage() {
      if (this.isFavoriteSaved) {
        return this.translations.favoritesSuccessMessageTmall;
      } else {
        return this.translations.favoritesErrorMessage;
      }
    }
  }
};
</script>